import { IContactItemDto, IContactItemDetail } from "../common/model/Core.model";
export const NORMALIZE_FOR_ACCENT = (str: string) =>
  str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()

export interface TimeRangeItem {
  code: string
  name: string
  metric: 'H' | 'D' | 'M' | 'Y' | 'TODAY' | 'YESTERDAY' | 'WEEK' | 'LAST_WEEK' | 'MONTH' | 'CUSTOM' // Hour, Day, Month, Year
  value: number
  default?: boolean
}

export const TIME_RANGE_ITEM_LIST: TimeRangeItem[] = [
  {
    code: '24h',
    name: 'ÚLTIMAS 24 HORAS',
    metric: 'H',
    value: 24,
  },
  {
    code: '3d',
    name: 'ÚLTIMOS 3 DÍAS',
    metric: 'D',
    value: 3,
  },
  {
    code: '7d',
    name: 'ÚLTIMOS 7 DÍAS',
    metric: 'D',
    value: 7,
  },
  {
    code: '14d',
    name: 'ÚLTIMOS 14 DÍAS',
    metric: 'D',
    value: 14,
  },
  {
    code: '30d',
    name: 'ÚLTIMOS 30 DÍAS',
    metric: 'D',
    value: 30,
  },
  {
    code: '60d',
    name: 'ÚLTIMOS 60 DÍAS',
    metric: 'D',
    value: 60,
  },
  {
    code: '90d',
    name: 'ÚLTIMOS 90 DÍAS',
    metric: 'D',
    value: 90,
  },
  // {
  //   code: '6m',
  //   name: 'ÚLTIMOS 6 MESES',
  //   metric: 'M',
  //   value: 6,
  // },
  // {
  //   code: '1y',
  //   name: 'ÚLTIMO AÑO',
  //   metric: 'Y',
  //   value: 1,
  // },
  // {
  //   code: '2y',
  //   name: 'ÚLTIMOS 2 AÑOS',
  //   metric: 'Y',
  //   value: 2,
  // },
  {
    code: '-',
    name: 'CUSTOM',
    metric: 'CUSTOM',
    value: 0,
  },
  {
    code: '0d',
    name: 'HOY',
    metric: 'TODAY',
    value: 0,
  },
  {
    code: '-1d',
    name: 'AYER',
    metric: 'YESTERDAY',
    value: 0,
  },
  {
    code: '0w',
    name: 'ESTA SEMANA',
    metric: 'WEEK',
    value: 0,
  },
  {
    code: '-1w',
    name: 'SEMANA ANTERIOR',
    metric: 'LAST_WEEK',
    value: 0,
  },
  {
    code: '0m',
    name: 'ESTE MES',
    metric: 'MONTH',
    value: 0,
  },
  // {
  //   code: '-1m',
  //   name: 'MES ANTERIOR',
  //   metric: 'LAST_MONTH',
  //   value: 0,
  // },
  // {
  //   code: '0y',
  //   name: 'ESTE AÑO',
  //   metric: 'YEAR',
  //   value: 0,
  // },
  // {
  //   code: '-1y',
  //   name: 'AÑO ANTERIOR',
  //   metric: 'LAST_YEAR',
  //   value: 0,
  // },
]

export const Constants = {
  LOCAL_STORAGE: {
    ID_TOKEN_KEY: 'idToken',
    TOKEN_TYPE_STORAGE_KEY: 'tokenType',
    EXPIRES_IN_STORAGE_KEY: 'expiresIn',
    ACCESS_TOKEN_STORAGE_KEY: 'accessToken',
    REFRESH_TOKEN_STORAGE_KEY: 'refreshToken',
  },
  TOKENS: {
    IS_TOKEN_REFRESHED: 'isTokenRefreshed',
    ID_TOKEN_STORAGE_KEY: 'idToken',
    TOKEN_TYPE_STORAGE_KEY: 'tokenType',
    EXPIRES_IN_STORAGE_KEY: 'expiresIn',
    ACCESS_TOKEN_STORAGE_KEY: 'accessToken',
    REFRESH_TOKEN_STORAGE_KEY: 'refreshToken',
  },
  APP_ROUTES: {
    HOME: '/dashboard/home',
    SIGN_IN: '/signin'
  },
};

export const sanitizeContactInfo = (contacts: IContactItemDto[]) => {
  return contacts.map(contact => {
    const newContact: IContactItemDto = {
      primary: contact.primary,
      displayName: contact.displayName?.toUpperCase() ?? '',
      details: contact.details
        ? contact.details.map((detail) => {
            return {
              type: detail.type,
              value: detail.value?.toUpperCase() ?? '',
            }
          })
        : [],
    }
    return newContact
  })
}

export const renderIdentifier = (id: string = '') => {
  return `ID. ${id}`
}

export const COUNTRIES_EN = [
  // {code: 'AF', name: 'AFGHANISTAN'},
  // {code: 'AX', name: 'ALAND ISLANDS'},
  // {code: 'AL', name: 'ALBANIA'},
  // {code: 'DZ', name: 'ALGERIA'},
  // {code: 'AS', name: 'AMERICAN SAMOA'},
  // {code: 'AD', name: 'ANDORRA'},
  // {code: 'AO', name: 'ANGOLA'},
  // {code: 'AI', name: 'ANGUILLA'},
  // {code: 'AQ', name: 'ANTARCTICA'},
  // {code: 'AG', name: 'ANTIGUA AND BARBUDA'},
  // {code: 'AR', name: 'ARGENTINA'},
  // {code: 'AM', name: 'ARMENIA'},
  // {code: 'AW', name: 'ARUBA'},
  // {code: 'AU', name: 'AUSTRALIA'},
  // {code: 'AT', name: 'AUSTRIA'},
  // {code: 'AZ', name: 'AZERBAIJAN'},
  // {code: 'BS', name: 'BAHAMAS'},
  // {code: 'BH', name: 'BAHRAIN'},
  // {code: 'BD', name: 'BANGLADESH'},
  // {code: 'BB', name: 'BARBADOS'},
  // {code: 'BY', name: 'BELARUS'},
  // {code: 'BE', name: 'BELGIUM'},
  {code: 'BZ', name: 'BELIZE'},
  // {code: 'BJ', name: 'BENIN'},
  // {code: 'BM', name: 'BERMUDA'},
  // {code: 'BT', name: 'BHUTAN'},
  // {code: 'BO', name: 'BOLIVIA, PLURINATIONAL STATE OF'},
  // {code: 'BQ', name: 'BONAIRE, SINT EUSTATIUS AND SABA'},
  // {code: 'BA', name: 'BOSNIA AND HERZEGOVINA'},
  // {code: 'BW', name: 'BOTSWANA'},
  // {code: 'BV', name: 'BOUVET ISLAND'},
  // {code: 'BR', name: 'BRAZIL'},
  // {code: 'IO', name: 'BRITISH INDIAN OCEAN TERRITORY'},
  // {code: 'BN', name: 'BRUNEI DARUSSALAM'},
  // {code: 'BG', name: 'BULGARIA'},
  // {code: 'BF', name: 'BURKINA FASO'},
  // {code: 'BI', name: 'BURUNDI'},
  // {code: 'KH', name: 'CAMBODIA'},
  // {code: 'CM', name: 'CAMEROON'},
  {code: 'CA', name: 'CANADA'},
  // {code: 'CV', name: 'CAPE VERDE'},
  // {code: 'KY', name: 'CAYMAN ISLANDS'},
  // {code: 'CF', name: 'CENTRAL AFRICAN REPUBLIC'},
  // {code: 'TD', name: 'CHAD'},
  // {code: 'CL', name: 'CHILE'},
  // {code: 'CN', name: 'CHINA'},
  // {code: 'CX', name: 'CHRISTMAS ISLAND'},
  // {code: 'CC', name: 'COCOS (KEELING) ISLANDS'},
  // {code: 'CO', name: 'COLOMBIA'},
  // {code: 'KM', name: 'COMOROS'},
  // {code: 'CG', name: 'CONGO'},
  // {code: 'CD', name: 'CONGO, THE DEMOCRATIC REPUBLIC OF THE'},
  // {code: 'CK', name: 'COOK ISLANDS'},
  {code: 'CR', name: 'COSTA RICA'},
  // {code: 'CI', name: "CÔTE D'IVOIRE"},
  // {code: 'HR', name: 'CROATIA'},
  // {code: 'CU', name: 'CUBA'},
  // {code: 'CW', name: 'CURAÇAO'},
  // {code: 'CY', name: 'CYPRUS'},
  // {code: 'CZ', name: 'CZECH REPUBLIC'},
  // {code: 'DK', name: 'DENMARK'},
  // {code: 'DJ', name: 'DJIBOUTI'},
  // {code: 'DM', name: 'DOMINICA'},
  // {code: 'DO', name: 'DOMINICAN REPUBLIC'},
  // {code: 'EC', name: 'ECUADOR'},
  // {code: 'EG', name: 'EGYPT'},
  {code: 'SV', name: 'EL SALVADOR'},
  // {code: 'GQ', name: 'EQUATORIAL GUINEA'},
  // {code: 'ER', name: 'ERITREA'},
  // {code: 'EE', name: 'ESTONIA'},
  // {code: 'ET', name: 'ETHIOPIA'},
  // {code: 'FK', name: 'FALKLAND ISLANDS (MALVINAS)'},
  // {code: 'FO', name: 'FAROE ISLANDS'},
  // {code: 'FJ', name: 'FIJI'},
  // {code: 'FI', name: 'FINLAND'},
  // {code: 'FR', name: 'FRANCE'},
  // {code: 'GF', name: 'FRENCH GUIANA'},
  // {code: 'PF', name: 'FRENCH POLYNESIA'},
  // {code: 'TF', name: 'FRENCH SOUTHERN TERRITORIES'},
  // {code: 'GA', name: 'GABON'},
  // {code: 'GM', name: 'GAMBIA'},
  // {code: 'GE', name: 'GEORGIA'},
  // {code: 'DE', name: 'GERMANY'},
  // {code: 'GH', name: 'GHANA'},
  // {code: 'GI', name: 'GIBRALTAR'},
  // {code: 'GR', name: 'GREECE'},
  // {code: 'GL', name: 'GREENLAND'},
  // {code: 'GD', name: 'GRENADA'},
  // {code: 'GP', name: 'GUADELOUPE'},
  // {code: 'GU', name: 'GUAM'},
  {code: 'GT', name: 'GUATEMALA'},
  // {code: 'GG', name: 'GUERNSEY'},
  // {code: 'GN', name: 'GUINEA'},
  // {code: 'GW', name: 'GUINEA-BISSAU'},
  // {code: 'GY', name: 'GUYANA'},
  // {code: 'HT', name: 'HAITI'},
  // {code: 'HM', name: 'HEARD ISLAND AND MCDONALD ISLANDS'},
  // {code: 'VA', name: 'HOLY SEE (VATICAN CITY STATE)'},
  {code: 'HN', name: 'HONDURAS'},
  // {code: 'HK', name: 'HONG KONG'},
  // {code: 'HU', name: 'HUNGARY'},
  // {code: 'IS', name: 'ICELAND'},
  // {code: 'IN', name: 'INDIA'},
  // {code: 'ID', name: 'INDONESIA'},
  // {code: 'IR', name: 'IRAN, ISLAMIC REPUBLIC OF'},
  // {code: 'IQ', name: 'IRAQ'},
  // {code: 'IE', name: 'IRELAND'},
  // {code: 'IM', name: 'ISLE OF MAN'},
  // {code: 'IL', name: 'ISRAEL'},
  // {code: 'IT', name: 'ITALY'},
  // {code: 'JM', name: 'JAMAICA'},
  // {code: 'JP', name: 'JAPAN'},
  // {code: 'JE', name: 'JERSEY'},
  // {code: 'JO', name: 'JORDAN'},
  // {code: 'KZ', name: 'KAZAKHSTAN'},
  // {code: 'KE', name: 'KENYA'},
  // {code: 'KI', name: 'KIRIBATI'},
  // {code: 'KP', name: "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF"},
  // {code: 'KW', name: 'KUWAIT'},
  // {code: 'KG', name: 'KYRGYZSTAN'},
  // {code: 'LA', name: "LAO PEOPLE'S DEMOCRATIC REPUBLIC"},
  // {code: 'LV', name: 'LATVIA'},
  // {code: 'LB', name: 'LEBANON'},
  // {code: 'LS', name: 'LESOTHO'},
  // {code: 'LR', name: 'LIBERIA'},
  // {code: 'LY', name: 'LIBYA'},
  // {code: 'LI', name: 'LIECHTENSTEIN'},
  // {code: 'LT', name: 'LITHUANIA'},
  // {code: 'LU', name: 'LUXEMBOURG'},
  // {code: 'MO', name: 'MACAO'},
  // {code: 'MK', name: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF'},
  // {code: 'MG', name: 'MADAGASCAR'},
  // {code: 'MW', name: 'MALAWI'},
  // {code: 'MY', name: 'MALAYSIA'},
  // {code: 'MV', name: 'MALDIVES'},
  // {code: 'ML', name: 'MALI'},
  // {code: 'MT', name: 'MALTA'},
  // {code: 'MH', name: 'MARSHALL ISLANDS'},
  // {code: 'MQ', name: 'MARTINIQUE'},
  // {code: 'MR', name: 'MAURITANIA'},
  // {code: 'MU', name: 'MAURITIUS'},
  // {code: 'YT', name: 'MAYOTTE'},
  {code: 'MX', name: 'MEXICO'},
  // {code: 'FM', name: 'MICRONESIA, FEDERATED STATES OF'},
  // {code: 'MD', name: 'MOLDOVA, REPUBLIC OF'},
  // {code: 'MC', name: 'MONACO'},
  // {code: 'MN', name: 'MONGOLIA'},
  // {code: 'ME', name: 'MONTENEGRO'},
  // {code: 'MS', name: 'MONTSERRAT'},
  // {code: 'MA', name: 'MOROCCO'},
  // {code: 'MZ', name: 'MOZAMBIQUE'},
  // {code: 'MM', name: 'MYANMAR'},
  // {code: 'NA', name: 'NAMIBIA'},
  // {code: 'NR', name: 'NAURU'},
  // {code: 'NP', name: 'NEPAL'},
  // {code: 'NL', name: 'NETHERLANDS'},
  // {code: 'NC', name: 'NEW CALEDONIA'},
  // {code: 'NZ', name: 'NEW ZEALAND'},
  {code: 'NI', name: 'NICARAGUA'},
  // {code: 'NE', name: 'NIGER'},
  // {code: 'NG', name: 'NIGERIA'},
  // {code: 'NU', name: 'NIUE'},
  // {code: 'NF', name: 'NORFOLK ISLAND'},
  // {code: 'MP', name: 'NORTHERN MARIANA ISLANDS'},
  // {code: 'NO', name: 'NORWAY'},
  // {code: 'OM', name: 'OMAN'},
  // {code: 'PK', name: 'PAKISTAN'},
  // {code: 'PW', name: 'PALAU'},
  // {code: 'PS', name: 'PALESTINIAN TERRITORY, OCCUPIED'},
  {code: 'PA', name: 'PANAMA'},
  // {code: 'PG', name: 'PAPUA NEW GUINEA'},
  // {code: 'PY', name: 'PARAGUAY'},
  // {code: 'PE', name: 'PERU'},
  // {code: 'PH', name: 'PHILIPPINES'},
  // {code: 'PN', name: 'PITCAIRN'},
  // {code: 'PL', name: 'POLAND'},
  // {code: 'PT', name: 'PORTUGAL'},
  // {code: 'PR', name: 'PUERTO RICO'},
  // {code: 'QA', name: 'QATAR'},
  // {code: 'RE', name: 'RÉUNION'},
  // {code: 'RO', name: 'ROMANIA'},
  // {code: 'RU', name: 'RUSSIAN FEDERATION'},
  // {code: 'RW', name: 'RWANDA'},
  // {code: 'BL', name: 'SAINT BARTHÉLEMY'},
  // {code: 'SH', name: 'SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA'},
  // {code: 'KN', name: 'SAINT KITTS AND NEVIS'},
  // {code: 'LC', name: 'SAINT LUCIA'},
  // {code: 'MF', name: 'SAINT MARTIN (FRENCH PART)'},
  // {code: 'PM', name: 'SAINT PIERRE AND MIQUELON'},
  // {code: 'VC', name: 'SAINT VINCENT AND THE GRENADINES'},
  // {code: 'WS', name: 'SAMOA'},
  // {code: 'SM', name: 'SAN MARINO'},
  // {code: 'ST', name: 'SAO TOME AND PRINCIPE'},
  // {code: 'SA', name: 'SAUDI ARABIA'},
  // {code: 'SN', name: 'SENEGAL'},
  // {code: 'RS', name: 'SERBIA'},
  // {code: 'SC', name: 'SEYCHELLES'},
  // {code: 'SL', name: 'SIERRA LEONE'},
  // {code: 'SG', name: 'SINGAPORE'},
  // {code: 'SX', name: 'SINT MAARTEN (DUTCH PART)'},
  // {code: 'SK', name: 'SLOVAKIA'},
  // {code: 'SI', name: 'SLOVENIA'},
  // {code: 'SB', name: 'SOLOMON ISLANDS'},
  // {code: 'SO', name: 'SOMALIA'},
  // {code: 'ZA', name: 'SOUTH AFRICA'},
  // {code: 'GS', name: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS'},
  // {code: 'KR', name: 'SOUTH KOREA'},
  // {code: 'SS', name: 'SOUTH SUDAN'},
  // {code: 'ES', name: 'SPAIN'},
  // {code: 'LK', name: 'SRI LANKA'},
  // {code: 'SD', name: 'SUDAN'},
  // {code: 'SR', name: 'SURINAME'},
  // {code: 'SJ', name: 'SVALBARD AND JAN MAYEN'},
  // {code: 'SZ', name: 'SWAZILAND'},
  // {code: 'SE', name: 'SWEDEN'},
  // {code: 'CH', name: 'SWITZERLAND'},
  // {code: 'SY', name: 'SYRIAN ARAB REPUBLIC'},
  // {code: 'TW', name: 'TAIWAN, PROVINCE OF CHINA'},
  // {code: 'TJ', name: 'TAJIKISTAN'},
  // {code: 'TZ', name: 'TANZANIA, UNITED REPUBLIC OF'},
  // {code: 'TH', name: 'THAILAND'},
  // {code: 'TL', name: 'TIMOR-LESTE'},
  // {code: 'TG', name: 'TOGO'},
  // {code: 'TK', name: 'TOKELAU'},
  // {code: 'TO', name: 'TONGA'},
  // {code: 'TT', name: 'TRINIDAD AND TOBAGO'},
  // {code: 'TN', name: 'TUNISIA'},
  // {code: 'TR', name: 'TURKEY'},
  // {code: 'TM', name: 'TURKMENISTAN'},
  // {code: 'TC', name: 'TURKS AND CAICOS ISLANDS'},
  // {code: 'TV', name: 'TUVALU'},
  // {code: 'UG', name: 'UGANDA'},
  // {code: 'UA', name: 'UKRAINE'},
  // {code: 'AE', name: 'UNITED ARAB EMIRATES'},
  // {code: 'GB', name: 'UNITED KINGDOM'},
  {code: 'US', name: 'UNITED STATES'},
  // {code: 'UY', name: 'URUGUAY'},
  // {code: 'UZ', name: 'UZBEKISTAN'},
  // {code: 'VU', name: 'VANUATU'},
  // {code: 'VE', name: 'VENEZUELA, BOLIVARIAN REPUBLIC OF'},
  // {code: 'VN', name: 'VIETNAM'},
  // {code: 'VI', name: 'VIRGIN ISLANDS'},
  // {code: 'WF', name: 'WALLIS AND FUTUNA'},
  // {code: 'EH', name: 'WESTERN SAHARA'},
  // {code: 'YE', name: 'YEMEN'},
  // {code: 'ZM', name: 'ZAMBIA'},
  // {code: 'ZW', name: 'ZIMBABWE'},
]
export const COUNTRY_MAP_EN = new Map(COUNTRIES_EN.map((country) => [country.code, country.name]))

const COUNTRIES_ES = [
  // {code: 'AF', name: 'AFGANISTÁN'},
  // {code: 'AX', name: 'ISLAS ÅLAND'},
  // {code: 'AL', name: 'ALBANIA'},
  // {code: 'DZ', name: 'ARGELIA'},
  // {code: 'AS', name: 'SAMOA AMERICANA'},
  // {code: 'AD', name: 'ANDORRA'},
  // {code: 'AO', name: 'ANGOLA'},
  // {code: 'AI', name: 'ANGUILLA'},
  // {code: 'AQ', name: 'ANTÁRTIDA'},
  // {code: 'AG', name: 'ANTIGUA Y BARBUDA'},
  // {code: 'AR', name: 'ARGENTINA'},
  // {code: 'AM', name: 'ARMENIA'},
  // {code: 'AW', name: 'ARUBA'},
  // {code: 'AU', name: 'AUSTRALIA'},
  // {code: 'AT', name: 'AUSTRIA'},
  // {code: 'AZ', name: 'AZERBAIYÁN'},
  // {code: 'BS', name: 'BAHAMAS'},
  // {code: 'BH', name: 'BARÉIN'},
  // {code: 'BD', name: 'BANGLADÉS'},
  // {code: 'BB', name: 'BARBADOS'},
  // {code: 'BY', name: 'BIELORRUSIA'},
  // {code: 'BE', name: 'BÉLGICA'},
  {code: 'BZ', name: 'BELICE'},
  // {code: 'BJ', name: 'BENÍN'},
  // {code: 'BM', name: 'BERMUDAS'},
  // {code: 'BT', name: 'BUTÁN'},
  // {code: 'BO', name: 'BOLIVIA, ESTADO PLURINACIONAL DE'},
  // {code: 'BQ', name: 'BONAIRE, SAN EUSTAQUIO Y SABA'},
  // {code: 'BA', name: 'BOSNIA Y HERZEGOVINA'},
  // {code: 'BW', name: 'BOTSUANA'},
  // {code: 'BV', name: 'ISLA BOUVET'},
  // {code: 'BR', name: 'BRASIL'},
  // {code: 'IO', name: 'TERRITORIO BRITÁNICO DEL OCÉANO ÍNDICO'},
  // {code: 'BN', name: 'BRUNÉI DARUSSALAM'},
  // {code: 'BG', name: 'BULGARIA'},
  // {code: 'BF', name: 'BURKINA FASO'},
  // {code: 'BI', name: 'BURUNDI'},
  // {code: 'KH', name: 'CAMBOYA'},
  // {code: 'CM', name: 'CAMERÚN'},
  {code: 'CA', name: 'CANADÁ'},
  // {code: 'CV', name: 'CABO VERDE'},
  // {code: 'KY', name: 'ISLAS CAYMAN'},
  // {code: 'CF', name: 'REPÚBLICA CENTROAFRICANA'},
  // {code: 'TD', name: 'CHAD'},
  // {code: 'CL', name: 'CHILE'},
  // {code: 'CN', name: 'CHINA'},
  // {code: 'CX', name: 'ISLA DE NAVIDAD'},
  // {code: 'CC', name: 'ISLAS COCOS (KEELING)'},
  // {code: 'CO', name: 'COLOMBIA'},
  // {code: 'KM', name: 'COMORAS'},
  // {code: 'CG', name: 'CONGO'},
  // {code: 'CD', name: 'CONGO, REPÚBLICA DEMOCRÁTICA DEL'},
  // {code: 'CK', name: 'ISLAS COOK'},
  {code: 'CR', name: 'COSTA RICA'},
  // {code: 'CI', name: 'COSTA DE MARFIL'},
  // {code: 'HR', name: 'CROACIA'},
  // {code: 'CU', name: 'CUBA'},
  // {code: 'CW', name: 'CURAÇAO'},
  // {code: 'CY', name: 'CHIPRE'},
  // {code: 'CZ', name: 'REPÚBLICA CHECA'},
  // {code: 'DK', name: 'DINAMARCA'},
  // {code: 'DJ', name: 'YIBUTI'},
  // {code: 'DM', name: 'DOMINICA'},
  // {code: 'DO', name: 'REPÚBLICA DOMINICANA'},
  // {code: 'EC', name: 'ECUADOR'},
  // {code: 'EG', name: 'EGIPTO'},
  {code: 'SV', name: 'EL SALVADOR'},
  // {code: 'GQ', name: 'GUINEA ECUATORIAL'},
  // {code: 'ER', name: 'ERITREA'},
  // {code: 'EE', name: 'ESTONIA'},
  // {code: 'ET', name: 'ETIOPÍA'},
  // {code: 'FK', name: 'ISLAS MALVINAS (FALKLAND)'},
  // {code: 'FO', name: 'ISLAS FEROE'},
  // {code: 'FJ', name: 'FIYI'},
  // {code: 'FI', name: 'FINLANDIA'},
  // {code: 'FR', name: 'FRANCIA'},
  // {code: 'GF', name: 'GUAYANA FRANCESA'},
  // {code: 'PF', name: 'POLINESIA FRANCESA'},
  // {code: 'TF', name: 'TERRITORIOS AUSTRALES FRANCESES'},
  // {code: 'GA', name: 'GABÓN'},
  // {code: 'GM', name: 'GAMBIA'},
  // {code: 'GE', name: 'GEORGIA'},
  // {code: 'DE', name: 'ALEMANIA'},
  // {code: 'GH', name: 'GHANA'},
  // {code: 'GI', name: 'GIBRALTAR'},
  // {code: 'GR', name: 'GRECIA'},
  // {code: 'GL', name: 'GROENLANDIA'},
  // {code: 'GD', name: 'GRANADA'},
  // {code: 'GP', name: 'GUADALUPE'},
  // {code: 'GU', name: 'GUAM'},
  {code: 'GT', name: 'GUATEMALA'},
  // {code: 'GG', name: 'GUERNSEY'},
  // {code: 'GN', name: 'GUINEA'},
  // {code: 'GW', name: 'GUINEA-BISÁU'},
  // {code: 'GY', name: 'GUYANA'},
  // {code: 'HT', name: 'HAITÍ'},
  // {code: 'HM', name: 'ISLAS HEARD Y MCDONALD'},
  // {code: 'VA', name: 'SANTA SEDE (ESTADO DE LA CIUDAD DEL VATICANO)'},
  {code: 'HN', name: 'HONDURAS'},
  // {code: 'HK', name: 'HONG KONG'},
  // {code: 'HU', name: 'HUNGRÍA'},
  // {code: 'IS', name: 'ISLANDIA'},
  // {code: 'IN', name: 'INDIA'},
  // {code: 'ID', name: 'INDONESIA'},
  // {code: 'IR', name: 'IRÁN, REPÚBLICA ISLÁMICA DE'},
  // {code: 'IQ', name: 'IRAQ'},
  // {code: 'IE', name: 'IRLANDA'},
  // {code: 'IM', name: 'ISLA DE MAN'},
  // {code: 'IL', name: 'ISRAEL'},
  // {code: 'IT', name: 'ITALIA'},
  // {code: 'JM', name: 'JAMAICA'},
  // {code: 'JP', name: 'JAPÓN'},
  // {code: 'JE', name: 'JERSEY'},
  // {code: 'JO', name: 'JORDANIA'},
  // {code: 'KZ', name: 'KAZAJISTÁN'},
  // {code: 'KE', name: 'KENIA'},
  // {code: 'KI', name: 'KIRIBATI'},
  // {code: 'KP', name: 'COREA, REPÚBLICA POPULAR DEMOCRÁTICA DE'},
  // {code: 'KW', name: 'KUWAIT'},
  // {code: 'KG', name: 'KIRGUISTÁN'},
  // {code: 'LA', name: 'REPÚBLICA DEMOCRÁTICA POPULAR LAO'},
  // {code: 'LV', name: 'LETONIA'},
  // {code: 'LB', name: 'LÍBANO'},
  // {code: 'LS', name: 'LESOTO'},
  // {code: 'LR', name: 'LIBERIA'},
  // {code: 'LY', name: 'LIBIA'},
  // {code: 'LI', name: 'LIECHTENSTEIN'},
  // {code: 'LT', name: 'LITUANIA'},
  // {code: 'LU', name: 'LUXEMBURGO'},
  // {code: 'MO', name: 'MACAO'},
  // {code: 'MK', name: 'MACEDONIA, EX-REPÚBLICA YUGOSLAVA DE'},
  // {code: 'MG', name: 'MADAGASCAR'},
  // {code: 'MW', name: 'MALAUI'},
  // {code: 'MY', name: 'MALASIA'},
  // {code: 'MV', name: 'MALDIVAS'},
  // {code: 'ML', name: 'MALÍ'},
  // {code: 'MT', name: 'MALTA'},
  // {code: 'MH', name: 'ISLAS MARSHALL'},
  // {code: 'MQ', name: 'MARTINICA'},
  // {code: 'MR', name: 'MAURITANIA'},
  // {code: 'MU', name: 'MAURICIO'},
  // {code: 'YT', name: 'MAYOTTE'},
  {code: 'MX', name: 'MÉXICO'},
  // {code: 'FM', name: 'MICRONESIA, ESTADOS FEDERADOS DE'},
  // {code: 'MD', name: 'MOLDAVIA, REPÚBLICA DE'},
  // {code: 'MC', name: 'MÓNACO'},
  // {code: 'MN', name: 'MONGOLIA'},
  // {code: 'ME', name: 'MONTENEGRO'},
  // {code: 'MS', name: 'MONTSERRAT'},
  // {code: 'MA', name: 'MARRUECOS'},
  // {code: 'MZ', name: 'MOZAMBIQUE'},
  // {code: 'MM', name: 'MYANMAR'},
  // {code: 'NA', name: 'NAMIBIA'},
  // {code: 'NR', name: 'NAURU'},
  // {code: 'NP', name: 'NEPAL'},
  // {code: 'NL', name: 'PAÍSES BAJOS'},
  // {code: 'NC', name: 'NUEVA CALEDONIA'},
  // {code: 'NZ', name: 'NUEVA ZELANDA'},
  {code: 'NI', name: 'NICARAGUA'},
  // {code: 'NE', name: 'NÍGER'},
  // {code: 'NG', name: 'NIGERIA'},
  // {code: 'NU', name: 'NIUE'},
  // {code: 'NF', name: 'ISLA NORFOLK'},
  // {code: 'MP', name: 'ISLAS MARIANAS DEL NORTE'},
  // {code: 'NO', name: 'NORUEGA'},
  // {code: 'OM', name: 'OMÁN'},
  // {code: 'PK', name: 'PAKISTÁN'},
  // {code: 'PW', name: 'PALAOS'},
  // {code: 'PS', name: 'TERRITORIO PALESTINO OCUPADO'},
  {code: 'PA', name: 'PANAMÁ'},
  // {code: 'PG', name: 'PAPÚA NUEVA GUINEA'},
  // {code: 'PY', name: 'PARAGUAY'},
  // {code: 'PE', name: 'PERÚ'},
  // {code: 'PH', name: 'FILIPINAS'},
  // {code: 'PN', name: 'ISLAS PITCAIRN'},
  // {code: 'PL', name: 'POLONIA'},
  // {code: 'PT', name: 'PORTUGAL'},
  // {code: 'PR', name: 'PUERTO RICO'},
  // {code: 'QA', name: 'CATAR'},
  // {code: 'RE', name: 'REUNIÓN'},
  // {code: 'RO', name: 'RUMANÍA'},
  // {code: 'RU', name: 'FEDERACIÓN RUSA'},
  // {code: 'RW', name: 'RUANDA'},
  // {code: 'BL', name: 'SAN BARTOLOMÉ'},
  // {code: 'SH', name: 'SANTA ELENA, ASCENSIÓN Y TRISTÁN DE ACUÑA'},
  // {code: 'KN', name: 'SAN CRISTÓBAL Y NIEVES'},
  // {code: 'LC', name: 'SANTA LUCÍA'},
  // {code: 'MF', name: 'SAN MARTÍN (PARTE FRANCESA)'},
  // {code: 'PM', name: 'SAN PEDRO Y MIQUELÓN'},
  // {code: 'VC', name: 'SAN VICENTE Y LAS GRANADINAS'},
  // {code: 'WS', name: 'SAMOA'},
  // {code: 'SM', name: 'SAN MARINO'},
  // {code: 'ST', name: 'SANTO TOMÉ Y PRÍNCIPE'},
  // {code: 'SA', name: 'ARABIA SAUDITA'},
  // {code: 'SN', name: 'SENEGAL'},
  // {code: 'RS', name: 'SERBIA'},
  // {code: 'SC', name: 'SEYCHELLES'},
  // {code: 'SL', name: 'SIERRA LEONA'},
  // {code: 'SG', name: 'SINGAPUR'},
  // {code: 'SX', name: 'SINT MAARTEN (PARTE HOLANDESA)'},
  // {code: 'SK', name: 'ESLOVAQUIA'},
  // {code: 'SI', name: 'ESLOVENIA'},
  // {code: 'SB', name: 'ISLAS SALOMÓN'},
  // {code: 'SO', name: 'SOMALIA'},
  // {code: 'ZA', name: 'SUDÁFRICA'},
  // {code: 'GS', name: 'ISLAS GEORGIA DEL SUR Y SANDWICH DEL SUR'},
  // {code: 'KR', name: 'COREA DEL SUR'},
  // {code: 'SS', name: 'SUDÁN DEL SUR'},
  // {code: 'ES', name: 'ESPAÑA'},
  // {code: 'LK', name: 'SRI LANKA'},
  // {code: 'SD', name: 'SUDÁN'},
  // {code: 'SR', name: 'SURINAM'},
  // {code: 'SJ', name: 'SVALBARD Y JAN MAYEN'},
  // {code: 'SZ', name: 'ESWATINI'},
  // {code: 'SE', name: 'SUECIA'},
  // {code: 'CH', name: 'SUIZA'},
  // {code: 'SY', name: 'REPÚBLICA ÁRABE SIRIA'},
  // {code: 'TW', name: 'TAIWÁN, PROVINCIA DE CHINA'},
  // {code: 'TJ', name: 'TAYIKISTÁN'},
  // {code: 'TZ', name: 'TANZANIA, REPÚBLICA UNIDA DE'},
  // {code: 'TH', name: 'TAILANDIA'},
  // {code: 'TL', name: 'TIMOR-LESTE'},
  // {code: 'TG', name: 'TOGO'},
  // {code: 'TK', name: 'TOKELAU'},
  // {code: 'TO', name: 'TONGA'},
  // {code: 'TT', name: 'TRINIDAD Y TOBAGO'},
  // {code: 'TN', name: 'TÚNEZ'},
  // {code: 'TR', name: 'TURQUÍA'},
  // {code: 'TM', name: 'TURKMENISTÁN'},
  // {code: 'TC', name: 'ISLAS TURCAS Y CAICOS'},
  // {code: 'TV', name: 'TUVALU'},
  // {code: 'UG', name: 'UGANDA'},
  // {code: 'UA', name: 'UCRANIA'},
  // {code: 'AE', name: 'EMIRATOS ÁRABES UNIDOS'},
  // {code: 'GB', name: 'REINO UNIDO'},
  {code: 'US', name: 'ESTADOS UNIDOS'},
  // {code: 'UY', name: 'URUGUAY'},
  // {code: 'UZ', name: 'UZBEKISTÁN'},
  // {code: 'VU', name: 'VANUATU'},
  // {code: 'VE', name: 'VENEZUELA, REPÚBLICA BOLIVARIANA DE'},
  // {code: 'VN', name: 'VIETNAM'},
  // {code: 'VI', name: 'ISLAS VÍRGENES'},
  // {code: 'WF', name: 'WALLIS Y FUTUNA'},
  // {code: 'EH', name: 'SAHARA OCCIDENTAL'},
  // {code: 'YE', name: 'YEMEN'},
  // {code: 'ZM', name: 'ZAMBIA'},
  // {code: 'ZW', name: 'ZIMBABUE'},
]
const COUNTRY_MAP_ES = new Map(COUNTRIES_ES.map((country) => [country.code, country.name]))

export const SECTORS = ['COMMERCE', 'COMMUNICATIONS', 'FINANCIAL', 'GOVERNMENT', 'INDUSTRY', 'OTHER']
export enum FREQUENCY {
  MONTHLY = 'MONTHLY',
  BIMONTHLY = 'BIMONTHLY',
  QUARTERLY = 'QUARTERLY',
  CUATRIMESTRAL = 'CUATRIMESTRAL',
  SEMESTRAL = 'SEMESTRAL',
  ANNUAL = 'ANNUAL',
  OTHER = 'OTHER',
}
export const FREQUENCIES = [
  FREQUENCY.MONTHLY,
  FREQUENCY.BIMONTHLY,
  FREQUENCY.QUARTERLY,
  FREQUENCY.CUATRIMESTRAL,
  FREQUENCY.SEMESTRAL,
  FREQUENCY.ANNUAL,
  FREQUENCY.OTHER,
]
export const SERVICE_TYPES = ['GOLD', 'SILVER', 'ON_DEMAND']
export const DOCUMENT_TYPES = ['CONTRACT', 'PURCHASE_ORDER', 'APPROVAL_OF_OFFER']